const enrichmentState = {
  openOnLoad: false, // set to true when opening a url that already contains a fgid
  activeEnrichment: null,
  nextEnrichment: null,
}

export default enrichmentState
